(function () {
  'use strict';

  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function parseCutoff(value) {
    var parts = (value || '14:00').split(':');
    return { h: parseInt(parts[0], 10) || 14, m: parseInt(parts[1], 10) || 0 };
  }

  function addBusinessDays(from, days, skipWeekends) {
    var d = new Date(from.getTime());
    var added = 0;
    while (added < days) {
      d.setDate(d.getDate() + 1);
      if (skipWeekends && (d.getDay() === 0 || d.getDay() === 6)) continue;
      added++;
    }
    return d;
  }

  function formatCountdown(ms) {
    if (ms <= 0) return '0h 0m';
    var totalMin = Math.floor(ms / 60000);
    var h = Math.floor(totalMin / 60);
    var m = totalMin % 60;
    return h + 'h ' + m + 'm';
  }

  function weekdayName(date, locale) {
    try {
      return date.toLocaleDateString(locale, { weekday: 'long' });
    } catch (e) {
      return date.toLocaleDateString(undefined, { weekday: 'long' });
    }
  }

  function capitalize(s) {
    return s.charAt(0).toUpperCase() + s.slice(1);
  }

  function tick(root) {
    if (root.dataset.dynamic !== 'true') return;

    var cutoff = parseCutoff(root.dataset.cutoff);
    var deliveryDays = parseInt(root.dataset.deliveryDays, 10) || 2;
    var skipWeekends = root.dataset.skipWeekends === 'true';
    var locale = root.dataset.locale || 'es-ES';
    var now = new Date();

    var cutoffToday = new Date(now);
    cutoffToday.setHours(cutoff.h, cutoff.m, 0, 0);

    var countdownMs = cutoffToday - now;
    if (countdownMs <= 0) {
      cutoffToday.setDate(cutoffToday.getDate() + 1);
      countdownMs = cutoffToday - now;
    }

    var deliveryDate = addBusinessDays(cutoffToday, deliveryDays, skipWeekends);
    var countdownText = formatCountdown(countdownMs);
    var dateText = capitalize(weekdayName(deliveryDate, locale));

    root.querySelectorAll('[data-pdb-countdown]').forEach(function (el) {
      el.textContent = countdownText;
    });
    root.querySelectorAll('[data-pdb-delivery-date]').forEach(function (el) {
      el.textContent = dateText;
    });

    if (root.__pdbMarquee) {
      root.__pdbMarquee.syncTrack();
    }
  }

  function ProductDeliveryMarquee(root) {
    this.root = root;
    this.track = root.querySelector('.product-delivery-bar__track');
    this.group = root.querySelector('.product-delivery-bar__group:not([aria-hidden])');
    this.marquee = root.querySelector('.product-delivery-bar__marquee');
    this.scrollEnabled = root.dataset.pdbScroll === 'true';
    this.speedPx = parseFloat(root.dataset.pdbSpeedPx) || 70;
    this.pauseOnHover = root.dataset.pdbPauseOnHover === 'true';
    this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.resizeTimer = null;
    this.eventsBound = false;

    this.onMouseEnter = this.onMouseEnter.bind(this);
    this.onMouseLeave = this.onMouseLeave.bind(this);
    this.onFocusIn = this.onFocusIn.bind(this);
    this.onFocusOut = this.onFocusOut.bind(this);
    this.onResize = this.onResize.bind(this);
    this.onVisibilityChange = this.onVisibilityChange.bind(this);

    if (!this.scrollEnabled || !this.track || !this.group || !this.marquee) return;

    this.init();
  }

  ProductDeliveryMarquee.prototype.init = function () {
    if (this.reducedMotion) {
      this.root.classList.add('is-static');
      return;
    }

    var self = this;
    var start = function () {
      self.syncTrack();
      self.bindEvents();
    };

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(start).catch(start);
    } else {
      start();
    }
  };

  ProductDeliveryMarquee.prototype.prepareTrack = function () {
    var template = this.group;
    if (!template || !this.track || !this.marquee) return false;

    Array.from(this.track.querySelectorAll('.product-delivery-bar__group')).forEach(function (group) {
      if (group !== template) {
        group.remove();
      }
    });

    template.removeAttribute('aria-hidden');

    var marqueeWidth = this.marquee.clientWidth;
    if (marqueeWidth <= 0) return false;

    var groupWidth = Math.ceil(template.getBoundingClientRect().width);
    if (groupWidth <= 0) return false;

    if (groupWidth <= marqueeWidth + 2) {
      this.root.classList.add('is-static');
      this.root.style.removeProperty('--pdb-shift');
      this.root.style.removeProperty('--pdb-duration');
      return true;
    }

    this.root.classList.remove('is-static');

    var clone = template.cloneNode(true);
    clone.setAttribute('aria-hidden', 'true');
    this.track.appendChild(clone);

    var targetWidth = marqueeWidth + groupWidth * 2;
    var safety = 0;
    while (this.track.scrollWidth < targetWidth && safety < 24) {
      var extra = template.cloneNode(true);
      extra.setAttribute('aria-hidden', 'true');
      this.track.appendChild(extra);
      safety += 1;
    }

    this.root.style.setProperty('--pdb-shift', '-' + groupWidth + 'px');
    return true;
  };

  ProductDeliveryMarquee.prototype.updateDuration = function () {
    if (!this.prepareTrack()) return;

    if (this.root.classList.contains('is-static')) return;

    var shift = Math.abs(parseFloat(this.root.style.getPropertyValue('--pdb-shift')) || 0);
    if (shift <= 0) return;

    var duration = shift / this.speedPx;
    duration = Math.max(duration, 8);
    this.root.style.setProperty('--pdb-duration', duration + 's');
  };

  ProductDeliveryMarquee.prototype.syncTrack = function () {
    var self = this;
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        self.updateDuration();
      });
    });
  };

  ProductDeliveryMarquee.prototype.bindEvents = function () {
    if (this.eventsBound) return;
    this.eventsBound = true;

    window.addEventListener('resize', this.onResize);
    document.addEventListener('visibilitychange', this.onVisibilityChange);

    if (this.pauseOnHover) {
      this.root.addEventListener('mouseenter', this.onMouseEnter);
      this.root.addEventListener('mouseleave', this.onMouseLeave);
      this.root.addEventListener('focusin', this.onFocusIn);
      this.root.addEventListener('focusout', this.onFocusOut);
    }
  };

  ProductDeliveryMarquee.prototype.onResize = function () {
    clearTimeout(this.resizeTimer);
    this.resizeTimer = setTimeout(function () {
      this.syncTrack();
    }.bind(this), 150);
  };

  ProductDeliveryMarquee.prototype.onMouseEnter = function () {
    this.root.classList.add('is-paused');
  };

  ProductDeliveryMarquee.prototype.onMouseLeave = function () {
    this.root.classList.remove('is-paused');
  };

  ProductDeliveryMarquee.prototype.onFocusIn = function () {
    this.onMouseEnter();
  };

  ProductDeliveryMarquee.prototype.onFocusOut = function (event) {
    if (!this.root.contains(event.relatedTarget)) {
      this.onMouseLeave();
    }
  };

  ProductDeliveryMarquee.prototype.onVisibilityChange = function () {
    if (document.hidden) {
      this.root.classList.add('is-paused');
    } else {
      this.root.classList.remove('is-paused');
    }
  };

  ProductDeliveryMarquee.prototype.destroy = function () {
    window.removeEventListener('resize', this.onResize);
    document.removeEventListener('visibilitychange', this.onVisibilityChange);
  };

  function initRoot(root) {
    if (root.__pdbMarquee && root.__pdbMarquee.destroy) {
      root.__pdbMarquee.destroy();
    }

    if (root.dataset.pdbScroll === 'true') {
      root.__pdbMarquee = new ProductDeliveryMarquee(root);
    }

    if (root.dataset.dynamic === 'true') {
      tick(root);
      if (!root.__pdbTickInterval) {
        root.__pdbTickInterval = setInterval(function () {
          tick(root);
        }, 60000);
      }
    }
  }

  function initAll(scope) {
    var context = scope || document;
    context.querySelectorAll('[data-product-delivery-bar]').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
